module.exports = "pegasus_template/assets/theme3/header-image.jpg";